// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m2-1";
export var rowFirst = "_m2-3";
export var rowLast = "_m2-5";
export var rowMiddle = "_m2-4";
export var ticketListScroll = "_m2-2";
export var ticketStack = "_m2-0";